import { render, staticRenderFns } from "./LocsPersonalTable.vue?vue&type=template&id=8d38bf16&scoped=true"
import script from "./LocsPersonalTable.vue?vue&type=script&lang=js"
export * from "./LocsPersonalTable.vue?vue&type=script&lang=js"
import style0 from "./LocsPersonalTable.vue?vue&type=style&index=0&id=8d38bf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d38bf16",
  null
  
)

export default component.exports